import PropTypes from 'prop-types';
import UIMediaBody from 'UIComponents/layout/UIMediaBody';
import { jsx as _jsx } from "react/jsx-runtime";
const TileMessageContent = ({
  children
}) => /*#__PURE__*/_jsx(UIMediaBody, {
  children: children
});
TileMessageContent.displayName = 'TileMessageContent';
TileMessageContent.propTypes = {
  children: PropTypes.node.isRequired
};
export default TileMessageContent;